/* global System */

export default {
  InfoGraphic: () =>
    System.import(/* webpackChunkName: "InfoGraphic" */ './index'),
}
